import { confirmContactDetails } from '~/src/features/domofon/purchase/actions/confirmContactDetails';
import fillPerson from '~/src/features/domofon/purchase/actions/fillPerson';
import fillPhone from '~/src/features/domofon/purchase/actions/fillPhone';
import EEquipmentPurchaseActions from '~/src/features/domofon/purchase/constants/actions';
import { InitialState } from '~/src/features/domofon/purchase/reducer/initialState';

export type TContactDetailsActions =
    | typeof confirmContactDetails
    | typeof fillPerson
    | typeof fillPhone;

const contactDetailsReducer = (
    state: InitialState,
    action: ReturnType<TContactDetailsActions>,
): InitialState => {
    switch (action.type) {
        case EEquipmentPurchaseActions.FILL_PERSON: {
            return {
                ...state,
                person: action.payload,
            };
        }
        case EEquipmentPurchaseActions.FILL_PHONE: {
            return {
                ...state,
                phone: action.payload,
            };
        }
        case EEquipmentPurchaseActions.CONFIRM_CONTACT_DETAILS: {
            return {
                ...state,
                isContactDetailsConfirmed: action.payload,
            };
        }
    }
};

export default contactDetailsReducer;
